import "./footer.css";
import SocialLinks from "./SocialLinks";
import IndustryLinks from "./IndustryLinks";
import LegalLinks from "./LegalLinks";

export default function Footer() {
 return (
  <footer>
   <div className="d-flex flex-column flex-grow-1">
    <SocialLinks />
    <div className="d-flex justify-content-between py-4">
     <IndustryLinks />
     <LegalLinks />
    </div>
    <div className="d-flex justify-content-between p-0 m-0">
     <div className="footer-legal-container d-flex flex-column align-items-start">
      <p className="info-link">This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" className="info-link">Privacy Policy</a> and <a href="https://policies.google.com/terms" className="info-link">Terms of Service</a> apply.</p>
      <p className="fs-md mb-0 info-link"><span>© {new Date().getFullYear()}. All rights reserved. Property of <a href="https://dev4.online" className="info-link">DEV4 Online Ltd</a>.</span></p>
     </div>
     <iframe className="cyber-cert" src="https://registry.blockmarktech.com/certificates/42ef6744-a420-4590-91f6-0422e29f5154/widget/?tooltip_position=above&theme=transparent" title="Cyber Essentials Certification Badge"
      role="img"
      aria-label="Cyber Essentials Certification Badge"
      loading="lazy"></iframe>
    </div>
   </div>
  </footer>
 )
}